import PropTypes from 'prop-types';

export default function TooltipPanel({ children }) {
	return (
		<div className="max-w-sm break-words rounded-card border border-bgBase-500 bg-white px-3 py-2 text-sm text-text shadow-elevated">
			{children}
		</div>
	);
}

TooltipPanel.propTypes = {
	children: PropTypes.node.isRequired,
};
